import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { TabsComponent } from '@vg-constellation/angular-16/tabs';
import { Subscription } from 'rxjs';
import { AdobeLaunchService } from 'src/app/shared/services/adobe-launch.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { GradeMaterials } from 'src/app/shared/models/grade-materials.model';
import { K1_MATERIALS } from '../materials/k-1.materials';

@Component({
  selector: 'gradesk-1',
  templateUrl: './grades-k-1.component.html',
  styleUrls: ['./grades-k-1.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GradesK1Component implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('jobsTabs') jobsTabs: TabsComponent;
  private langChangeSubscription!: Subscription;

  k1Materials: GradeMaterials = K1_MATERIALS;

  // Getting Started Section
  @ViewChild('howWork') howWorkSection!: ElementRef;
  @ViewChild('curStand') curStandSection!: ElementRef;

  // Planning Section
  @ViewChild('proOut') proOutSection!: ElementRef;
  @ViewChild('jobBon') jobBonSection!: ElementRef;
  @ViewChild('prepMat') prepMatSection!: ElementRef;

  // Activities Section
  @ViewChild('firstDay') firstDaySection!: ElementRef;
  @ViewChild('schoolStore') schoolStoreSection!: ElementRef;
  @ViewChild('yearEnd') yearEndSection!: ElementRef;

  // Classroom Materials Section
  @ViewChild('classMaterials') classMaterialsSection!: ElementRef;
  
  constructor(
    public modalService: ModalService,
    private readonly adobeLaunchService: AdobeLaunchService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.adobeLaunchService.trackPageView({
      pageTitle:'Grades K to 1'
    });

    // Safety net: update labels if language changes mid-session without a reload
    this.langChangeSubscription = this.translateService.onLangChange.subscribe((_: LangChangeEvent) => {
      this.updateTabLabels();
    });
  }

  ngAfterViewInit(): void {
    // LanguageGuard calls translateService.use() before this component is
    // instantiated, so onLangChange has already fired by the time ngOnInit
    // subscribes. Populate labels immediately with the already-active language.
    this.updateTabLabels();
  }

  private updateTabLabels(): void {
    this.jobsTabs?.menuData?.items?.forEach(tab => {
      tab.labelText = this.translateService.instant('grades.table.header.' + (tab.tabPanelId || ''));
    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }

  onSidebarNavClick(elementName: string): void {
    const sectionMap: { [key: string]: ElementRef } = {
      // Getting Started Section
      howWork: this.howWorkSection,
      curStand: this.curStandSection,

      // Planning Section
      proOut: this.proOutSection,
      jobBon: this.jobBonSection,
      prepMat: this.prepMatSection,

      // Activities Section
      firstDay: this.firstDaySection,
      schoolStore: this.schoolStoreSection,
      yearEnd: this.yearEndSection,

      // Classroom Materials Section
      classMaterials: this.classMaterialsSection,
    };

    const targetSection = sectionMap[elementName];
    if (targetSection) {
      setTimeout(() => {
        targetSection.nativeElement.focus({ preventScroll: true });
      }, 0);
    }
  }
}
